export function hasCookie(name: string) {
    return document.cookie.split(';').some((c) => c.trim().startsWith(`${name}=`));
}

export function getCookieValue(name: string): string | undefined {
    return document.cookie
        .split(';')
        .find((cookie) => cookie.trim().startsWith(name))
        ?.trim()
        ?.replace(`${name}=`, '');
}
